import React, { Component }  from 'react';
import connect from "react-redux/es/connect/connect";
import { message, Alert } from "antd";

import Sidebar from "../../components/Modules/Sidebar";
import StripeComponent from "../../components/StripeComponent/StripeComponent";

import { auth, initUser } from "../../services/firebase/firebase";
import { getAllChatsOfUserListener } from "../../services/firebase/chats";

import { loadUserClaimsAction, loadUserDataAction } from "../../actions/userStoreActions";
import { getEventsAction } from "../../actions/eventsStoreActions";
import { getChannelsAction, getSubscriptionsAction } from "../../actions/channelsStoreActions";
import { popupPaymentStore, selectPaymentEvent } from "../../actions/optionsStoreActions";
import { moderateChatsAction, updateMessageNotification } from "../../actions/chatStoreActions";

import './root.less'

const conformity = {
  "Channels": "/Channels",
  "Past_EventsSurgeries": "/Surgeries",
  "Past_EventsConferences": "/Conferences",
  "Past_EventsWebinars": "/Webinars",
  "Upcoming_events": "/UpcomingEvents",
  "Subscriptions": "/Subscriptions",
  "Saved_events": "/Saved-events",
  "Messages": "/Messages",
  "Admin_configuration1": "/Admin_configuration/1",
  "Admin_configuration2": "/Admin_configuration/2",
  "Event_Editor": "/Event_Editor",
  "profile": "/profile"
};

const eventArrayRoutes = ["/Surgeries", "/Conferences", "/Webinars", "/UpcomingEvents"];

class Root extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userType: '',
      userClaims: {},
      currentKey: '/',
      unreadMessage: {
        count: 0,
        newMessages: false
      }
    };

    auth().onAuthStateChanged(user => {
      user && user.uid && initUser(user.uid, user.email, user.displayName)
        .then((res) => {
          if ('Admin' === res) {
            this.setState({ userType: 'Admin' });
            message.success('Admin permissions granted')
          } else if('Contributor' === res) {
            this.setState({ userType: 'Contributor' });
            message.success('Contributor permissions granted')
          } else {
            this.setState({ userType: 'User' });
          }
        });

        user && this.props.loadUserDataAction(user.uid).then((userData) => {
          if(userData && !userData.Email) {
            message.warning('Please, add email to your profile')
          }
        });

        user && this.props.loadUserClaimsAction(user);
        user && user.card && this.setState({ card: user.card });
        this.props.getChannelsAction();
        this.props.getSubscriptionsAction();
      });

    this.handlerClosePopup = this.handlerClosePopup.bind(this)
  }

  static getDerivedStateFromProps(props, state) {
    const url = window.location.href;
    const currentPage = url.split('#/')[1].replace('/', '');

    let currentKey;
    if (conformity[currentPage]) {
      currentKey = conformity[currentPage];
    } else {
      const parsedUrl = url.split('#/')[1].split('/')[0];
      currentKey = (parsedUrl === 'profile') ?
        parsedUrl : '/' + parsedUrl;
    }

    const { userClaims } = props.user;

    const haveUnreadMessages = {
      count: 0,
      newMessages: false
    };

    getAllChatsOfUserListener(function(chats) {
      const keys = Object.keys(chats);
      let count = 0;
      let newMessages = false;

      keys.forEach(key => {
        const haveConnectionWithUser = key.split('-').indexOf(userClaims.user_id) !== -1;
        haveConnectionWithUser && chats[key].forEach(message => {
          if (message.unread && message.userId !== userClaims.user_id) {
            newMessages = true;
            count++;
          }
        })
      })
      haveUnreadMessages.newMessages = newMessages;
      haveUnreadMessages.count = count;

      if (state.unreadMessage.count !== haveUnreadMessages.count) {
        props.updateMessageNotification(haveUnreadMessages);
      }
    }).then((res) => {});

    if (haveUnreadMessages.count !== state.unreadMessage.count) {
      return {
        unreadMessage: haveUnreadMessages
      }
    }

    if (state.currentKey !== currentKey) {
      return {
        currentKey: currentKey
      }
    }

    if (userClaims !== state.userClaims) {
      props.getEventsAction(userClaims, props.data.channels);

      return {
        userClaims: userClaims,
        loading: false
      };
    }

    return null;
  }

  callbackAllChatsOfUserListener(chats) {
    const { userClaims } = this.props.user;
    this.props.moderateChatsAction(chats, userClaims.user_id)
  }

  changePageHandler = (obj) => {
    this.setState(obj);
  };

  handlerClosePopup() {
    this.props.popupPaymentStore(false);
    this.props.selectPaymentEvent('');
  }

  render() {
    const { unreadMessage } = this.state;
    const { user, data, children, options } = this.props;
    const { userClaims } = user;
    const { events, channels, subscriptions, subscribeOptions } = data;

    const isAdmin = userClaims.userType === 'Admin';
    const isContributor = userClaims.userType === 'Contributor';

    let messageText = '';
    let eventWithoutUrlContributor = 0;

    let filteredEvents = events.filter(item => {
      const isUploadVideo = item.uploadVideo && item.uploadVideo.uploadVideoUrl;

      if (item.isUpcoming || item.youTubeUrl ||  item.videoEmbed || item.playlist || isUploadVideo) {
        return item
      }
    });
    if (userClaims && userClaims.user_id && isAdmin) {
      const eventsWithoutVideos = (events && events.length) - (filteredEvents && filteredEvents.length)

      if (eventsWithoutVideos && eventsWithoutVideos > 0) {
        messageText = `Please, specify video url for ${eventsWithoutVideos} past events`;
      }

      filteredEvents = events;
    }
    if (userClaims && userClaims.user_id && isContributor) {
      filteredEvents = events.filter(item => {
        const eventChannelId = item.channel.id;
        const сorСhannel = channels.filter(channel => channel.id === eventChannelId)[0];
        const hasRightForChannel = сorСhannel && сorСhannel.ownerId && сorСhannel.ownerId.indexOf(user.uid) !== -1;

        const isUploadVideo = item.uploadVideo && item.uploadVideo.uploadVideoUrl;
        // const isUpcoming = Events.isUpcoming(item.date);

        if (hasRightForChannel && (item.youTubeUrl || item.videoEmbed || item.playlist || isUploadVideo)) {
          eventWithoutUrlContributor++
        }

        if (item.isUpcoming || item.youTubeUrl || item.videoEmbed || item.playlist || hasRightForChannel || isUploadVideo) {
          return item
        }
      });

      messageText = eventWithoutUrlContributor !== 0 &&
        `Please, specify video url for ${eventWithoutUrlContributor} past events`;
    }

    const childrenWithProps = React.Children.map(children, child => {
      return React.cloneElement(child, {
        user: user,
        data: data,
        channels: channels,
        subscriptions: subscriptions,
        subscribeOptions: subscribeOptions,
        events: filteredEvents
      })
    });

    const isMatch = eventArrayRoutes.includes(this.state.currentKey);

    return (
      <div className="root">
        <div className="route-wr">
          <Sidebar
            user={this.props.user}
            data={this.props.data}
            currentKey={this.state.currentKey}
            changePageHandler={this.changePageHandler}
            unreadMessage={unreadMessage}
          />

          <div className="main-wrapper">
            {messageText && isMatch && (
                <Alert
                  message={messageText}
                  type="warning"
                  closable
                />
              )
            }
            {childrenWithProps}
          </div>

          <StripeComponent
            user={user}
            events={events}
            options={options}
            handlerClosePopup={this.handlerClosePopup}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      data: state.data,
      user: state.user,
      options: state.options
    };
  },
  {
    loadUserClaimsAction,
    getEventsAction,
    loadUserDataAction,
    getChannelsAction,
    getSubscriptionsAction,
    moderateChatsAction,
    updateMessageNotification,
    popupPaymentStore,
    selectPaymentEvent,
  }
)(Root);



// WEBPACK FOOTER //
// ./src/pages/Root/index.js